<template>
  <div>
    <app-mappy :loading="loading" @stop-loading="loading=false"></app-mappy>
  </div>
</template>

<script>
import Mappy from './Mappy.vue';

export default {
  name: 'Layout',
  components: {
    appMappy: Mappy,
  },
  data: function () {
    return {
      loading: true
    };
  },
  methods: {}
};
</script>

<style>

</style>
